import {
    Box,
    Button,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    TextField
} from "@mui/material";
import React, {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useRejectReasonsQuery} from "../../../../store/api/requestApi";
import {updateSelectedLines} from "../../../../store/slice/bidComparsionChart";

const RejectDialog = ({rejectDialog, setRejectDialog}) => {
    const dispatch = useDispatch()
    const [comment, setComment] = useState('')
    const [rejectReason, setRejectReason] = useState('')
    const {data} = useRejectReasonsQuery()
    const selectedLines = useSelector((state) => state.bidComparsionSlice.selectedLines)
    const selectedSequenceFromWFA = useSelector((state) => state.bidComparsionSlice.selectedSequenceFromWFA)
    const comparsionChartData = useSelector((state) => state.bidComparsionSlice.comparsionChartData)

    const save = () => {
        const newData = {...selectedLines}
        newData[rejectDialog?.index] = {
            comment,
            rejectReasonId: rejectReason,
            rfqDeatilid: rejectDialog?.rfqDetailId,
            sequence: selectedSequenceFromWFA,
            approveStatus: 2,
            bidMainId: comparsionChartData?.bids?.[0]?.bidMainId
        }
        setRejectDialog(null)
        dispatch(updateSelectedLines(newData))
    }

    const close = () => {
        dispatch(updateSelectedLines({...selectedLines}))
        setRejectDialog(null)
    }

    return (
        <>
            <DialogTitle>
                Reject
            </DialogTitle>
            <DialogContent>
                <Box sx={{mt: 2}}>
                    <FormControl fullWidth size="small">
                        <InputLabel>Reject Reason</InputLabel>
                        <Select
                            label="Reject Reason"
                            value={rejectReason}
                            size="small"
                            fullWidth
                            onChange={e => setRejectReason(e.target.value)}
                        >
                            {data?.data.map(item => (
                                <MenuItem key={item.rejectReasonId} value={item.rejectReasonId}>
                                    {item?.reasonName}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>
                <Box sx={{mt: 2}}>
                    <FormControl fullWidth>
                        <TextField label="Comment" multiline value={comment}
                                   onChange={e => setComment(e.target.value)}
                                   rows={4}/>
                    </FormControl>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button variant='contained'
                        onClick={save}
                        disabled={!rejectReason || !comment}>Save</Button>
                <Button variant="outlined" onClick={close} sx={{color: 'gray', borderColor: '#D3D3D3'}}>
                    Cancel
                </Button>
            </DialogActions>
        </>
    )
}

export default RejectDialog